import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import SwivuSortColumn from "./SwivuSortColumn.jsx";
import { columnAvatarRenderer, columnAvatarString, EntityMainNameDefault, showToast, swivuGridSorterFn } from "../../other/utils/utils.jsx";

export default class NotifyBoardUserColumn extends SwivuSortColumn {
  static get $name() {
    return "NotifyBoardUserColumn";
  }

  static get type() {
    return WIDGET_KEYS.notifyBoardUserColumn;
  }

  static get fields() {
    return [
      { name: "canEmptySwivuList", type: "boolean", readOnly: true, defaultValue: false },
      { name: "swivuListTitle", type: "string", readOnly: true, defaultValue: "Board User" },
      { name: "swivuListSearchKey", type: "string", readOnly: true, defaultValue: "name" },
    ]
  }

  static get defaults() {
    return {
      editor: false
    }
  }

  get swivuListItems() {
    return this.project.boardUsersStore.query((boardUser) => !boardUser.isDeactivated, true).sort(swivuGridSorterFn.bind({ field: "name" }));
  }

  onLoad(project, { record, recordType }) {
    this.project = project;
    this.entityRecord = record;
    this.entityRecordType = recordType;
  }

  getSelectedSwivuListItem(notifyeeRecord) {
    return notifyeeRecord.boardUserId;
  }

  getSwivuListItemDisplayValue(boardUserRecord) {
    return columnAvatarString(boardUserRecord.name ,boardUserRecord.profileImageURL);
  }

  isBoardUserNotifyRecordExist(selectedBoardUser) {
    return this.project.notfiyeeBoardUserStore.find((nbu) => (
      nbu[this.entityRecordType] === this.entityRecord.id &&
      nbu.boardUserId === selectedBoardUser.id
    ));
  }

  onSwivuBeforeListSelectionChange(notifyeeRecord, [selectedBoardUser]) {
    if (notifyeeRecord.boardUserId !== selectedBoardUser.id && this.isBoardUserNotifyRecordExist(selectedBoardUser)) {
      showToast({ type: "error", msg: `Notify board user already exists` });
      return false;
    }
    return true;
  }

  onSwivuListSelectionChange(notifyeeRecord, [boardUserRecord]) {
    notifyeeRecord.boardUserId = boardUserRecord.id;
    if (notifyeeRecord.isPhantom) {
      this.project.notfiyeeBoardUserStore.add(notifyeeRecord);
    }
  }

  renderer({ record, grid }) {
    if (!record.isGroupHeader) {
      const boardUserRecord = record.boardUserRecord;
      return boardUserRecord ? columnAvatarRenderer({
        image: boardUserRecord.profileImageURL,
        name: boardUserRecord.name,
        size: grid.rowHeight,
      }) : EntityMainNameDefault();
    }
  }
}

ColumnStore.registerColumnType(NotifyBoardUserColumn);
